import { apiRequest } from "../client/httpClient";

export const cartApi = {
  getCart: () => apiRequest("/carts"),
  addItem: (productId, quantity, note) =>
    apiRequest("/carts/items", {
      method: "POST",
      body: JSON.stringify({ productId, quantity, note }),
    }),
  setItemQty: (productId, quantity, note = undefined) =>
    apiRequest(`/carts/items/${productId}`, {
      method: "PATCH",
      body: JSON.stringify(
        note === undefined ? { quantity } : { quantity, note }
      ),
    }),
  remove: (productId) =>
    apiRequest(`/carts/items/${productId}`, { method: "DELETE" }),
  applyVoucher: (code) =>
    apiRequest("/carts/voucher", {
      method: "PUT",
      body: JSON.stringify({ code }),
    }),
  removeVoucher: () => apiRequest("/carts/voucher", { method: "DELETE" }),
  clear: () => apiRequest("/carts", { method: "DELETE" }),
};







